import styled from "styled-components";
import React from "react";

import {
  Section,
  Image,
  // Header2,
  // Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

// import MonitorBg from "images/monitor.png";
import SavantPowerLogoGroup from "images/savantPowerLogoGroup.png";
import GELightingLogo from "images/geLightingLogo.png";
import SavantLogo from "images/savantLogo.png";

const LogoGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

export const IntroducingSavantPower = () => (
  <Section
    css={`
      padding-top: 90px;
      padding-bottom: 90px;
      justify-content: flex-center;
      flex-direction: column;
      height: auto;
    `}
  >
    <Paragraph
      css={`
        font-size: 20px;
        text-align: center;
        line-height: 24px;
        margin-top: 20px;
        margin-bottom: 30px;
        @media screen and (min-width: ${getSize("mobile375")}) {
          margin: 30px 40px;
        }
        @media screen and (min-width: ${getSize("tablet960")}) {
        }
        @media screen and (min-width: ${getSize("desktop1200")}) {
        }
        @media screen and (min-width: ${getSize("desktop1920")}) {
          margin: 30px 80px;
          width: 1050px;
        }
      `}
    >
      {
        "Racepoint Energy is now Savant Power. We\u2019re proud to join GE Lighting, a Savant company as the newest addition to Savant\u2019s portfolio of premium smart home solutions."
      }
    </Paragraph>

    <LogoGroup
      css={`
        @media screen and (min-width: ${getSize("tablet720")}) {
          margin-top: 42px;
          justify-content: flex-center;
        }
      `}
    >
      <div
        css={`
          height: auto;
          @media screen and (min-width: 0px) and (max-width: 719px) {
            flex-basis: 100%;
          }
          @media screen and (min-width: ${getSize("tablet720")}) {
            flex-basis: auto;
          }
          position: relative;
          object-fit: contain;
        `}
      >
        <Image
          css={`
            height: auto;
            @media screen and (min-width: 0px) and (max-width: 719px) {
              margin: auto;
              margin-bottom: 40px;
              width: 173px;
            }
            @media screen and (min-width: ${getSize("tablet720")}) {
              margin-right: 60px;
              width: 173px;
            }
            @media screen and (min-width: ${getSize("desktop1200")}) {
              margin-right: 82px;
              width: 275px;
            }
            position: relative;
            object-fit: contain;
          `}
          src={SavantLogo}
        />
      </div>

      <div
        css={`
          height: auto;
          @media screen and (min-width: 0px) and (max-width: 420px) {
            flex-basis: 100%;
          }
          @media screen and (min-width: ${getSize("tablet720")}) {
            flex-basis: auto;
          }
          position: relative;
          object-fit: contain;
        `}
      >
        <Image
          css={`
            height: auto;
            @media screen and (min-width: 0px) and (max-width: 420px) {
              margin: auto;
              margin-bottom: 40px;
              width: 150px;
            }
            @media screen and (min-width: 421px) and (max-width: 719px) {
              margin-right: 60px;
              width: 150px;
            }
            @media screen and (min-width: ${getSize("tablet720")}) {
              margin-right: 60px;
              width: 150px;
            }
            @media screen and (min-width: ${getSize("desktop1200")}) {
              margin-right: 82px;
              width: 237px;
            }
            position: relative;
            object-fit: contain;
          `}
          src={GELightingLogo}
        />
      </div>

      <Image
        css={`
          height: auto;
          @media screen and (min-width: 0px) and (max-width: 719px) {
            margin: 0px;
            width: 168px;
          }
          @media screen and (min-width: ${getSize("tablet720")}) {
            width: 168px;
          }
          @media screen and (min-width: ${getSize("desktop1200")}) {
            width: 268px;
          }
          position: relative;
          object-fit: contain;
        `}
        src={SavantPowerLogoGroup}
      />
    </LogoGroup>
  </Section>
);
